/*
 * Submit button, který
 * */
import WebComponent from '../../webComponents/WebComponent';
import { resolveExecute } from '../../partialUpdate';
import classNames from '../../lib/classNames';
import { getWebComponentInstance } from '../../webComponents/decorate';
// neimportuje se $ protože, chceme kompatibilitu i na webech bez jQuery k jquery se pak musí přistupovat přes window.$, aby se nehádalo popřípadě s jiným jquery na stránce


class ButtonSubmit extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      validationInProgress: false,
      submited: false,
    };
    this.handleAfterServerValidation = this.handleAfterServerValidation.bind(this);
    this.handleBeforeServerValidation = this.handleBeforeServerValidation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitComplete = this.handleSubmitComplete.bind(this);
  }

  didMount() {
    this.form = this.element.closest('form');
    this.innerHtml = this.element.innerHTML;
    if (this.form) {
      this.element.addEventListener('click', this.handleSubmit);
      this.form.addEventListener('submit', this.handleSubmit);
      this.form.addEventListener('beforeServerValidation', this.handleBeforeServerValidation);
      this.form.addEventListener('afterServerValidation', this.handleAfterServerValidation);
      this.liveValidationInstance = window.$(this.form).data('liveValidation');
    }
  }
  willUnMount() {
    this.element.removeEventListener('click', this.handleSubmit);
    this.form.removeEventListener('submit', this.handleSubmit);
    this.form.removeEventListener('beforeServerValidation', this.handleBeforeServerValidation);
    this.form.removeEventListener('afterServerValidation', this.handleAfterServerValidation);
    this.form = undefined;
    this.handleBeforeServerValidation = undefined;
    this.handleAfterServerValidation = undefined;
    this.handleSubmit = undefined;
    this.liveValidationInstance = undefined;
  }

  handleSubmit(e) {
    const { submited, validationInProgress } = this.state;
    console.log('handleSubmit this.state', this.state);
    // šlo by vynechat pokud není formu validní, ale potřebujeme zobrazit validační hlášky, tak je potřeba validaci vyvolat
    if (window.$ && !submited && !validationInProgress) {
      const liveValidationInstance = window.$(this.form).data('liveValidation');
      if (liveValidationInstance) {
        // mutable odstarnění validationContextId, aby se zvalidovalo vše
        liveValidationInstance.validationContextId = null;
        liveValidationInstance.validate(liveValidationInstance.finalSettings, window.$(this.form));
      }
    }
    this.setState({
      submited: true,
    });
    e.stopPropagation();
    e.preventDefault();
  }
  handleBeforeServerValidation(e) {
    this.setState({
      validationInProgress: true
    });
  }
  handleAfterServerValidation(e, result) {
    const data = result || e.detail.data;
    const { submited } = this.state;
    const isValid = Object.keys(data.widgets).map((key) => data.widgets[key].hasErrors).findIndex((val) => val === true) === -1;
    if(window.$ && submited && !isValid) {
      // bylo submitnuto, tak je potřeba označit všechny widgety, že byly visited, aby se zobrazyly u nich chyby
      const liveValidationInstance = window.$(this.form).data('liveValidation');
      if (liveValidationInstance) {
        Object.keys(data.widgets).forEach((key) => {
          liveValidationInstance.visitedInputs[data.widgets[key].widgetInputName] = true;
        });
      }
    }
    // předpokládá se, že je využit partialupdate, pokud je form validní, tak se provolá execute

    this.setState({
      submited: false,
      validationInProgress: false
    });

    if(submited && isValid) {
      this.setState({
        submited: true,
      });
      resolveExecute(
        this.element,
        {
          eventName: this.element.getAttribute('name'),
          onComplete: this.handleSubmitComplete,
          includeToProgress: false
        }
      );
    }


  }
  handleSubmitComplete() {
    this.setState({
      submited: false,
    });
  }
  update(prevProps, prevState, inDocument) {
    const { validationInProgress, submited } = this.state;
    const { loadingClassName, loadingMarkup } = this.props;
    const loading = validationInProgress || submited;
    this.element.disabled = loading;
    this.element.innerHTML = loading ? `${loadingMarkup}${this.innerHtml}` : this.innerHtml;
    classNames(this.element, {
      [loadingClassName]: loading
    });
  }
}

ButtonSubmit.defaultProps = {
  loadingClassName: 'btn__hasLoading',
  loadingMarkup: `
    <svg class="svg-icon svg-icon-spinner"><use href="/ver/_2F7p4gQONYIjUOBaZSxE/public/svg/svg-sprite.svg#spinner"></use></svg>
  `,
};

export default ButtonSubmit;




// WEBPACK FOOTER //
// ./node_modules/@fg/fg-frontend/src/components/formWithLiveValidation/ButtonSubmit.js